export default function LoadingContainer(props: { isReady: boolean, small?: boolean, className?: string, children?: any }): JSX.Element {
    var classes = "fixed"
    if (props.small) {
        classes = ""
    }
    return <>
        {props.isReady ? props.children : <div className={classes + 
            " inset-0 flex items-center justify-center bg-white/80 z-50 " + props.className}>
            <div className="flex space-x-2">
                <span className="sr-only">Loading...</span>
                <div className="h-3 w-3 bg-succ2 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
                <div className="h-3 w-3 bg-succ2 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
                <div className="h-3 w-3 bg-succ2 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
            </div>
        </div>}
    </>
}